import React from 'react';

const Header = () => {

    return (
        <header id='header-content'>
            <div id='header-title-content'>
                <h1 id='title-text'>Dogs and Doggos</h1>
            </div>

        </header>
    );
}

export default Header;